const GeneralFaqContentSF = [
  {
    title: 'What is Autzu?',
    info: [
      {
        pretext:
          'Autzu is a drivesharing platform offering versatile hourly and daily electric vehicle rentals for ride-sharing or food delivery services. Our fleet of well-maintained, clean vehicles are always prepared for your needs. Hourly rental fees start from $7/hour.'
      }
    ]
  },
  {
    title: 'What is drivesharing?',
    info: [
      {
        pretext:
          'Drivesharing allows multiple drivers to share the use of rideshare vehicles to transport passengers or deliveries. Drivesharing reduces overall traffic congestion and carbon emissions as the total number of vehicles on the road is reduced; Autzu accomplishes this by providing environmentally-sustainable solutions, such as electric vehicles.'
      }
    ]
  },
  {
    title: 'What is ridesharing?',
    info: [
      {
        pretext:
          'Ridesharing is any technology platform that connects driver partners with riders or delivery requests. As a driver, you will be able to use Autzu vehicles to pick up and transport passengers and deliveries, and will be paid a fare by the rideshare company for each completed trip.'
      }
    ]
  },
  {
    title: 'Which ridesharing apps can I use with Autzu?',
    info: [
      {
        pretext:
          'Autzu vehicles are currently eligible to accept passenger and food delivery trips using the Uber Driver app.'
      }
    ]
  },
  {
    title: 'What type of vehicles can I drive?',
    info: [
      {
        posttext:
          'We offer the sleek and high-performing Tesla Model 3 in both Long Range (333 mi) and Standard Range (272 mi) options. Our vehicles are automatically assigned for you based on fleet availability.'
      }
    ]
  },
  {
    title: 'What is the booking rate and what is included?',
    info: [
      {
        sublist: [
          [
            {
              listtitle: {
                title: 'Booking Rates',
                description:
                  ' - Dynamic pricing aligns prices with real-time demand, offering you the opportunity to save money during off-peak times'
              }
            },
            {
              text: {
                boldtext: 'Hourly Rate: ',
                plaintext: 'Starting from $7 per hour.'
              }
            },
            {
              listtitle: "What's Included in the Booking Rate?"
            },
            {
              text: {
                boldtext: 'Unlimited Mileage: ',
                plaintext:
                  'Drive as many miles as you need with no extra costs.'
              }
            },
            {
              text: {
                boldtext: 'General Maintenance: ',
                plaintext:
                  'All routine maintenance costs are covered, including regular wear-and-tear.'
              }
            },
            {
              text: {
                boldtext: 'Comprehensive Insurance: ',
                plaintext:
                  'This covers both damage to your rented vehicle and potential damage to other vehicles or property, ensuring peace of mind while you drive.'
              }
            },
            {
              text: {
                boldtext: 'Roadside Assistance: ',
                plaintext:
                  'In the event of a breakdown or any unexpected issue on the road, roadside assistance will be provided.'
              }
            },
            {
              text: {
                boldtext: '24/7 Emergency Support: ',
                plaintext:
                  'Around-the-clock support ensures you have someone to reach out to in case of any emergencies or urgent queries.'
              }
            }
          ]
        ]
      }
    ]
  },
  {
    title: 'What are the benefits of driving with Autzu?',
    info: [
      { pretext: 'Here are the benefits of driving with Autzu:' },
      {
        text: [
          {
            boldtext: 'Access to Electric Vehicles (EVs): ',
            plaintext:
              'With Autzu, you can access electric vehicles, allowing you to earn more on rideshare platforms while saving on charging costs compared to gasoline.'
          },

          {
            boldtext: 'No Long-Term Commitment: ',
            plaintext:
              'Autzu offers hourly and daily rentals allowing you to use the vehicle only when needed, without being tied down to long-term contracts or loans.'
          },
          {
            boldtext: 'Cost-Effective: ',
            plaintext:
              'Depending on the demand and availability, rental fees are competitive, allowing drivers to optimize their earnings.'
          },
          {
            boldtext:
              'No Need for Personal Vehicle Ownership or Wear and Tear: ',
            plaintext:
              "Using Autzu's vehicles for ridesharing or delivery means less wear and tear on your personal vehicle, creating substantial savings on maintenance and depreciation costs in the long run."
          },
          {
            boldtext: 'Environmental Benefits: ',
            plaintext:
              'By promoting the use of electric vehicles, drivers are contributing to reduced carbon emissions and promoting a more sustainable future.'
          }
        ]
      }
    ]
  },
  {
    title: 'When can I drive?',
    info: [
      {
        pretext: 'The following hours are when you can start your booking:'
      },
      { text: { plaintext: '1am, 3am, 5am, 7am, 9am, 11am' } },
      { text: { plaintext: '1pm, 3pm, 5pm, 7pm, 9pm, 11pm' } },
      {
        mixedPosttext: {
          leadingPosttext: 'Bookings must be a',
          boldPosttext: ' minimum of 6 hours, ',
          postingPosttext:
            'and you have the option to extend them in increments of 2 hours.'
        }
      },
      {
        mixedPosttext: {
          leadingPosttext: 'Alternatively, ',
          boldPosttext: 'you can choose daily bookings, ',
          postingPosttext:
            'allowing you to reserve a vehicle for up to a maximum of 7 days.'
        }
      }
    ]
  },
  {
    title: 'Can I book in advance?',
    info: [
      {
        pretext:
          'Yes, you can create bookings up to one year in advance. Booking in advance with Autzu offers the following advantages:'
      },
      {
        text: {
          boldtext: 'Getting Lower Rates: ',
          plaintext:
            'Autzu recommends booking in advance to secure a booking for the lowest price possible.'
        }
      },
      {
        text: {
          boldtext: 'Securing a Vehicle: ',
          plaintext:
            'By booking in advance, you can ensure that a vehicle is available for the specific times you want to drive. This is particularly useful during peak times or busy days when demand for vehicles may be high. '
        }
      }
    ]
  },
  {
    title: 'How does payment work?',
    info: [
      {
        text: [
          {
            boldtext: 'Rental Fee Charge: ',
            plaintext:
              'The rental fee for your booking will be charged to your payment method two hours prior to your booking begins.'
          },

          {
            boldtext: 'Extension & Supercharging Charges: ',
            plaintext:
              'If you decide to extend your booking or if you complete a Supercharging session, charges will be applied immediately after each respective action.'
          },
          {
            boldtext: 'Additional Fees: ',
            plaintext:
              'Any other fees (i.e. late fees or low-charge fees)  that may arise during your rental period will be charged at the end of your booking.'
          },
          {
            boldtext: 'Accepted Payment Methods: ',
            plaintext:
              'Autzu accepts all major credit and virtual debit cards.'
          }
        ]
      }
    ]
  },
  {
    title: 'What is your cancellation policy?',
    info: [
      {
        mixedPretext: {
          leadingPretext:
            'Our flexible cancellation policy allows you to cancel your bookings without any fees as long as you do so ',
          boldPretext: '24 hours before ',
          postingPretext: 'your start time.'
        }
      },
      {
        pretext:
          'You can cancel your booking directly through the Autzu app by heading over to your Dashboard.   '
      },
      {
        pretext: 'Our full cancellation policy is below:   '
      },
      {
        table: {
          title: ['Cancellation Time', 'Cancellation Fees'],
          rowContent1: [
            'More than 24 hours from the booking start time',
            'No charge'
          ],
          rowContent2: [
            '24 hours to 2 hours from the booking start time',
            '50% of total booking fee'
          ],
          rowContent3: [
            'Within 2 hours from the booking start time',
            '100% of total booking fee'
          ]
        }
      },
      {
        posttext:
          'Cancellation fees are structured this way to ensure Autzu can adequately dedicate vehicles to drivers based on their bookings. We do not overbook time slots, so last-minute cancellations result in a low probability of this vehicle being re-booked by another driver.'
      }
    ]
  },
  {
    title: 'Can I use Autzu vehicles for personal use?',
    info: [
      {
        pretext:
          'No, Autzu vehicles are designated exclusively for ridesharing purposes and are closely monitored to ensure compliance with this policy. Using them for personal activities is not permitted. In the event of an accident during unauthorized use, your Autzu account may be terminated.'
      }
    ]
  },
  {
    title:
      'Can I let someone else drive an Autzu vehicle using my account?',
    info: [
      {
        pretext:
          "You will be fully liable for any damages or incidents that occur if you let an unauthorized person drive the vehicle. It's essential to ensure that only authorized users operate the vehicle to prevent any potential issues or liabilities."
      }
    ]
  },
  {
    title: 'What does the insurance policy cover?',

    info: [
      {
        sublist: [
          [
            {
              listtitle: { title: 'Coverage when you’re offline:' }
            },
            {
              text: {
                plaintext:
                  'Autzu maintains commercial automobile insurance, which covers the cost of injuries or damages up to a combined single limit of $100,000.'
              }
            },
            {
              listtitle: {
                title:
                  'Coverage when you’re online and available for a trip (i.e. Uber):'
              }
            },
            {
              text: {
                plaintext:
                  'Autzu maintains commercial automobile insurance, which covers the cost of injuries or damages up to a combined single limit of $125,000.'
              }
            },
            {
              listtitle: {
                title:
                  'Coverage when you’re en route or on a trip (i.e. Uber):'
              }
            },
            {
              text: {
                plaintext:
                  'Uber maintains insurance that covers at least $1,000,000 for property damage and injuries to riders and third parties involved in an accident, no matter who’s at fault.'
              }
            }
          ]
        ],

        note:
          'Note: A $5,000 deductible applies if you are “at fault” for an accident during any of the above stages. This deductible can be reduced down to $1,000 if the reduced deductible option is added to your booking in advance.'
      }
    ]
  },
  {
    title: 'What is the Optional Deductible Reduction add-on?',

    info: [
      {
        pretext:
          'When you have an accident and are deemed at fault, you are required by law to pay an insurance deductible to cover the cost of repairs. You can reduce this insurance deductible from $5,000/$2,500 (offline/online) to $1,000 (offline/online) if you pay an extra $0.60 per hour (or $14.40 per day) at the time you create your booking.'
      }
    ]
  }
];

export default GeneralFaqContentSF;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/GeneralFaqContentSF.js